import React, { useState } from "react";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import prayersData from "../../source/prayers.json";

const PrayersPage = () => {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (sectionId) => {
    setExpandedSections((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  return (
    <>
      {/* Menu */}
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>

      {/* Title Section with Overlay */}
      <div className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white">Daily Prayers</h1>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="prayers-content container mt-5">
        <div className="prayer-intro">
          <h2 className="text-primary  text-center">Power of Prayer in Daily Life</h2>

          <blockquote className="scripture-quote">
            <i>
              "Whatever you ask in prayer, you will receive, if you have faith."
              (Matthew 21:22)
            </i>
          </blockquote>

          <p>
            We stand in the presence of the Lord with{" "}
            <strong>grateful hearts</strong>, acknowledging His greatness and
            seeking His presence in our lives. The Word of God assures us that{" "}
            <strong>trusting in Him</strong> brings understanding and love.
          </p>

          <blockquote className="scripture-quote">
            <i>
              "Those who trust in Him shall understand truth, and the faithful
              shall abide with Him in love. Because grace and mercy are with His
              holy ones, and His care is with the elect." (Wisdom 3:9)
            </i>
          </blockquote>

          <p>
            As children of the <strong>Most High</strong>, we are called to
            reflect His love and light in everything we do. Our actions should
            be guided by kindness, mirroring the compassion of our Lord. In
            times of need, the Bible exhorts us to pour out our hearts before
            Him in sincere prayer.
          </p>

          <h3 className="text-secondary  text-center mt-4">
            A Call to Deep and Earnest Prayer
          </h3>

          <blockquote className="scripture-quote">
            <i>
              "Rise up! Wail in the night, at the start of every watch; pour out
              your heart like water before the Lord; lift up your hands to Him
              for the lives of your children, who collapse from hunger at the
              corner of every street." (Lamentations 2:19)
            </i>
          </blockquote>

          <p>
            The Scriptures emphasize that{" "}
            <strong>prayer is not just words</strong> but a deep connection with
            God. It is through prayer that we draw strength, receive wisdom, and
            find peace in His presence.
          </p>

          <ul className="prayer-points">
            <li>
              <strong>Faithful prayer</strong> opens the doors of divine grace
              (Matthew 21:22).
            </li>
            <li>
              <strong>Trust in God</strong> leads to deeper spiritual
              understanding (Wisdom 3:9).
            </li>
            <li>
              <strong>Persistent prayer</strong> is a call to seek Him
              wholeheartedly (Lamentations 2:19).
            </li>
          </ul>
        </div>

        {/* Prayer Sections */}
        {prayersData.map((prayer) => (
          <div key={prayer.id} className="prayer-section">
            <h2
              className="prayer-title clickable"
              onClick={() => toggleSection(prayer.id)}
            >
              {expandedSections[prayer.id] ? "▲ " : "▼ "} {prayer.title}
            </h2>
            {expandedSections[prayer.id] && (
              <div className="prayer-text">
                {prayer.text.map((line, index) => (
                  <p key={index}>{line}</p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Footer */}
      <FooterPanel />
    </>
  );
};

export default PrayersPage;
